// extracted by mini-css-extract-plugin
export var back = "CourseSidebar-module--back--EypYf";
export var button = "CourseSidebar-module--button--fffp3";
export var course_name = "CourseSidebar-module--course_name--l6tbI";
export var dark_layer = "CourseSidebar-module--dark_layer--OziVe";
export var header = "CourseSidebar-module--header--UnMQp";
export var hide = "CourseSidebar-module--hide--1bUd2";
export var logo = "CourseSidebar-module--logo--ywv6-";
export var logo_wrapper = "CourseSidebar-module--logo_wrapper--ZXH1g";
export var premium_title = "CourseSidebar-module--premium_title--CcEQc";
export var scrollable = "CourseSidebar-module--scrollable--T6wBK";
export var show = "CourseSidebar-module--show--drZUN";
export var sidebar = "CourseSidebar-module--sidebar--8Qhj9";
export var title = "CourseSidebar-module--title--SX-lS";
export var videos = "CourseSidebar-module--videos--Pi3lk";
export var x = "CourseSidebar-module--x--tQmuq";